import React from 'react';
import _ from 'lodash';
import { BookingStatus } from 'utilities/enum-utils';
import { Moment } from 'moment';

import { CustomerDetailsColumn } from './CustomerDetailsColumn';
import { DayColumn } from './DayColumn';
import { NoShiftIndicator } from './no-shift-indicator';
import { IRosterBooking, IRosterCustomer } from '../../types';
import { GoodTable } from '@good/ui/templates';
import { BookingCardList } from './booking-card-list';
import { rosterConfig } from '../../roster-config';

interface CustomerItemRowProps {
  customer: IRosterCustomer;
  bookings: IRosterBooking[];
  days: Moment[];
}

export const CustomerItemRow = ({ customer, bookings, days }: CustomerItemRowProps) => {
  const { customerLastName, customerFirstName, customerAvatarUrl } = customer;
  const customerFullName = `${customerFirstName} ${customerLastName}`;
  const hasBookings = true;
  const revenueAmount = _.reduce(
    _.filter(
      bookings,
      (booking) =>
        booking.bookerUserId === customer.customerId &&
        !_.find(
          [
            BookingStatus.CUSTOMER_CANCELLED,
            BookingStatus.CUSTOMER_CANCELLED_WITHOUT_FEE,
            BookingStatus.BUSINESS_CANCELLED,
          ],
          (filteredStatus) => booking.status === filteredStatus,
        ),
    ),
    (acc, item) => {
      return acc + Number(item.total);
    },
    0,
  );

  return (
    <GoodTable.Tr>
      <GoodTable.Td sticky bg={rosterConfig.grayColor}>
        <CustomerDetailsColumn
          customerId={customer.customerId}
          customerName={customerFullName}
          revenueAmount={revenueAmount}
          avatarUrl={customerAvatarUrl}
        />
      </GoodTable.Td>
      {!hasBookings && (
        <GoodTable.Td>
          <NoShiftIndicator />
        </GoodTable.Td>
      )}

      {days.map((day, idx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <GoodTable.Td key={idx}>
          <DayColumn
            content={<BookingCardList customer={customer} day={day} bookings={bookings} />}
            hasAddAction={false}
          />
        </GoodTable.Td>
      ))}
    </GoodTable.Tr>
  );
};
